/** AreaLight3D property formatter: the inspector sections for an area light. */
import { formatNode3DProperties } from '../../../base/node3d/propertyFormatter';
import { formatBaseLightSection, formatShadowSectionWithNormalBias } from '../shared/propertyFormatter';
export function formatAreaLight3DProperties(properties) {
    const sections = [];
    const { x: w, y: h } = properties.area_size;
    const areaLightItems = [{ label: 'Size', value: `${w} × ${h}` }];
    sections.push(formatBaseLightSection(properties, areaLightItems));
    // No area-light-specific shadow rows: RectAreaLight has no shadow support,
    // so shadow_* is intentionally lossy at render (see Component.tsx). The
    // shared Shadows section is still shown for parity with sibling lights.
    sections.push(formatShadowSectionWithNormalBias(properties));
    sections.push(...formatNode3DProperties(properties));
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map